module.exports = __webpack_public_path__ + "3f117398ef1c4fe73b7aa3773eb16d7b.png";